import CallActionButtonComponent from './CallActionButton.component';

export * from './CallActionButton.component';
export default CallActionButtonComponent;